<template>
  <span class="metadata-display">
    <span v-if="topicsDisplayList" class="mr-1">
      <span>
        <span class="application-heading">Events:</span> {{ topicsDisplayList }}
      </span>
    </span>
    <span v-if="influenceDisplayList" class="mr-1">
      <span>
        <span class="application-heading">Influences:</span>
        {{ influenceDisplayList }}
      </span>
    </span>
    <div v-if="lineBreaks"></div>
    <span v-if="typeof sentiment === 'number'" class="pr-1">
      <span>
        <span class="application-heading">Sentiment:</span> {{ textSentiment }}
      </span>
    </span>
    <span v-if="textEmotions" class="pr-1">
      <span>
        <span class="application-heading">Emotions:</span> {{ textEmotions }}
      </span>
    </span>
    <span v-if="expanded && displaySeverity" class="pr-1">
      <span>
        <span class="application-heading">Severity:</span> {{ displaySeverity }}
      </span>
    </span>
    <span v-if="originalLanguage" class="pr-1">
      <span>
        <span class="application-heading">Original Language:</span>
        {{ originalLanguage }}
      </span>
    </span>
    <span v-if="reliability && isReliabilityFeatureUnlocked" class="pr-1">
      <span>
        <span class="application-heading">Source Reliability:</span>
        {{ reliability }}
      </span>
    </span>

    <div
      v-if="socialAuthenticity && isSocialAuthenticityFeatureUnlocked"
      class="pr-1 mt-2"
    >
      <span class="application-heading"
        >{{ socialAuthenticity }} (Account)</span
      >
    </div>

    <span v-if="analysisInfo">
      <div v-if="countries && countries.length" class="analysis-text">
        <DetailsListItemLocations
          :countries="countries"
          :theme="theme"
        ></DetailsListItemLocations>
      </div>
      <div v-if="waters && waters.length" class="analysis-text">
        <DetailsListItemLocations
          :waters="waters"
          :theme="theme"
        ></DetailsListItemLocations>
      </div>
      <div v-if="analysisInfo.risks" class="analysis-text">
        <span class="application-heading">Risks:</span> {{ analysisInfo.risks }}
      </div>
      <div v-if="analysisInfo.travelLevel" class="analysis-text">
        <span class="application-heading">Level:</span>
        {{ analysisInfo.travelLevel }}
      </div>
      <div
        v-if="analysisInfo.published && !analysisInfo.updated"
        class="analysis-text"
      >
        <span class="application-heading">Published:</span>
        <span v-html="analysisInfo.published" class="ml-1"></span>
      </div>
      <div v-if="analysisInfo.updated" class="analysis-text">
        <span class="application-heading">Updated:</span>
        <span v-html="analysisInfo.updated" class="ml-1"></span>
      </div>
      <div v-if="analysisInfo.tags" class="analysis-text">
        <span class="application-heading">Tags:</span>
        <span v-html="analysisInfo.tags" class="ml-1"></span>
      </div>
      <div v-if="analysisInfo.travelSource" class="analysis-text">
        <span class="application-heading">Source:</span>
        <span class="ml-1">{{ analysisInfo.travelSource }}</span>
      </div>
    </span>
  </span>
</template>

<script>
export default {
  // This component should *NOT* be used for verified events.
  // It implicitly assumes the data getting passed to it is not a verified event.
  name: "DetailsListItemExtras",
  props: {
    sentiment: {
      type: Number,
      required: false,
    },
    emotions: {
      type: Array,
      required: false,
    },
    reliability: {
      type: String,
      required: false,
    },
    socialAuthenticity: {
      type: String,
      required: false,
    },
    topicsDisplayList: {
      type: String,
      required: false,
    },
    influenceDisplayList: {
      type: String,
      required: false,
    },
    lineBreaks: {
      type: Boolean,
      default: false,
    },
    severity: {
      type: Number,
    },
    analysisInfo: {
      type: Object,
    },
    originalLanguage: {
      type: String,
      required: false,
    },
    countries: {
      type: Array,
      required: false,
    },
    waters: {
      type: Array,
      required: false,
    },
    theme: {
      type: String,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DetailsListItemLocations: () =>
      import("@/components/common/details/DetailsListItemLocations.vue"),
  },
  computed: {
    color() {
      if (typeof this.sentiment === "number") {
        if (this.sentiment > 1) {
          return "#00A100";
        } else if (this.sentiment < -1) {
          return "#F44436";
        }
      }
      return "#7B7B7B";
    },
    textSentiment() {
      if (typeof this.sentiment === "number") {
        if (this.sentiment > 1) {
          return "Positive";
        } else if (this.sentiment < -1) {
          return "Negative";
        }
        return "Neutral";
      }
      return null;
    },
    textEmotions() {
      if (this.emotions?.length) {
        return this.emotions
          .map((e) => {
            return e.charAt(0).toUpperCase() + e.substring(1);
          })
          .join(", ");
      }
      return null;
    },
    displaySeverity() {
      if (this.severity) {
        return this.severity > 5 ? "6-10" : "0-5";
      } else {
        return this.severity;
      }
    },
    isReliabilityFeatureUnlocked() {
      return this.featureUnlocked("livesearch-source-metadata-reliability");
    },
    isSocialAuthenticityFeatureUnlocked() {
      return this.featureUnlocked(
        "livesearch-source-metadata-social-authenticity"
      );
    },
  },
};
</script>

<style scoped>
.metadata-display {
  font-size: 10px;
  line-height: 1;
}
.analysis-text {
  line-height: 16px;
}
</style>
